/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Papacito dating app API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AuthResponse,
  DiscoverResponse,
  ErrorResponse,
  HealthStatus,
  LoginBody,
  MatchProfile,
  MatchProfileDetail,
  Message,
  MessagesResponse,
  OnboardingBody,
  PhotoResponse,
  RegisterBody,
  SendMessageBody,
  SwipeBody,
  SwipeLimitResponse,
  SwipeResult,
  SwipesRemainingResponse,
  Unmatch200,
  UpdateProfileBody,
  UploadPhotoBody,
  UserProfile,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register a new user
 */
export const getRegisterUrl = () => {
  return `/api/auth/register`;
};

export const register = async (
  registerBody: RegisterBody,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getRegisterUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerBody),
  });
};

export const getRegisterMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterBody> },
  TContext
> => {
  const mutationKey = ["register"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof register>>,
    { data: BodyType<RegisterBody> }
  > = (props) => {
    const { data } = props ?? {};

    return register(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof register>>
>;
export type RegisterMutationBody = BodyType<RegisterBody>;
export type RegisterMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Register a new user
 */
export const useRegister = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof register>>,
    TError,
    { data: BodyType<RegisterBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof register>>,
  TError,
  { data: BodyType<RegisterBody> },
  TContext
> => {
  return useMutation(getRegisterMutationOptions(options));
};

/**
 * @summary Login
 */
export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  loginBody: LoginBody,
  options?: RequestInit,
): Promise<AuthResponse> => {
  return customFetch<AuthResponse>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginBody),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginBody>;
export type LoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Login
 */
export const useLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Get current user
 */
export const getGetMeUrl = () => {
  return `/api/auth/me`;
};

export const getMe = async (options?: RequestInit): Promise<UserProfile> => {
  return customFetch<UserProfile>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update user profile
 */
export const getUpdateProfileUrl = () => {
  return `/api/users/profile`;
};

export const updateProfile = async (
  updateProfileBody: UpdateProfileBody,
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getUpdateProfileUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProfileBody),
  });
};

export const getUpdateProfileMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { data: BodyType<UpdateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { data: BodyType<UpdateProfileBody> },
  TContext
> => {
  const mutationKey = ["updateProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProfile>>,
    { data: BodyType<UpdateProfileBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProfile>>
>;
export type UpdateProfileMutationBody = BodyType<UpdateProfileBody>;
export type UpdateProfileMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Update user profile
 */
export const useUpdateProfile = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProfile>>,
    TError,
    { data: BodyType<UpdateProfileBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProfile>>,
  TError,
  { data: BodyType<UpdateProfileBody> },
  TContext
> => {
  return useMutation(getUpdateProfileMutationOptions(options));
};

/**
 * @summary Complete onboarding after signup
 */
export const getCompleteOnboardingUrl = () => {
  return `/api/users/onboarding`;
};

export const completeOnboarding = async (
  onboardingBody: OnboardingBody,
  options?: RequestInit,
): Promise<UserProfile> => {
  return customFetch<UserProfile>(getCompleteOnboardingUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(onboardingBody),
  });
};

export const getCompleteOnboardingMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeOnboarding>>,
    TError,
    { data: BodyType<OnboardingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeOnboarding>>,
  TError,
  { data: BodyType<OnboardingBody> },
  TContext
> => {
  const mutationKey = ["completeOnboarding"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeOnboarding>>,
    { data: BodyType<OnboardingBody> }
  > = (props) => {
    const { data } = props ?? {};

    return completeOnboarding(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteOnboardingMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeOnboarding>>
>;
export type CompleteOnboardingMutationBody = BodyType<OnboardingBody>;
export type CompleteOnboardingMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Complete onboarding after signup
 */
export const useCompleteOnboarding = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeOnboarding>>,
    TError,
    { data: BodyType<OnboardingBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeOnboarding>>,
  TError,
  { data: BodyType<OnboardingBody> },
  TContext
> => {
  return useMutation(getCompleteOnboardingMutationOptions(options));
};

/**
 * @summary Upload a profile photo (base64)
 */
export const getUploadPhotoUrl = () => {
  return `/api/users/photos`;
};

export const uploadPhoto = async (
  uploadPhotoBody: UploadPhotoBody,
  options?: RequestInit,
): Promise<PhotoResponse> => {
  return customFetch<PhotoResponse>(getUploadPhotoUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadPhotoBody),
  });
};

export const getUploadPhotoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadPhoto>>,
    TError,
    { data: BodyType<UploadPhotoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadPhoto>>,
  TError,
  { data: BodyType<UploadPhotoBody> },
  TContext
> => {
  const mutationKey = ["uploadPhoto"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadPhoto>>,
    { data: BodyType<UploadPhotoBody> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadPhoto(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadPhoto>>
>;
export type UploadPhotoMutationBody = BodyType<UploadPhotoBody>;
export type UploadPhotoMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Upload a profile photo (base64)
 */
export const useUploadPhoto = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadPhoto>>,
    TError,
    { data: BodyType<UploadPhotoBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadPhoto>>,
  TError,
  { data: BodyType<UploadPhotoBody> },
  TContext
> => {
  return useMutation(getUploadPhotoMutationOptions(options));
};

/**
 * @summary Delete a profile photo
 */
export const getDeletePhotoUrl = (photoId: number) => {
  return `/api/users/photos/${photoId}`;
};

export const deletePhoto = async (
  photoId: number,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePhotoUrl(photoId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePhotoMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePhoto>>,
    TError,
    { photoId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePhoto>>,
  TError,
  { photoId: number },
  TContext
> => {
  const mutationKey = ["deletePhoto"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePhoto>>,
    { photoId: number }
  > = (props) => {
    const { photoId } = props ?? {};

    return deletePhoto(photoId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePhoto>>
>;

export type DeletePhotoMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Delete a profile photo
 */
export const useDeletePhoto = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePhoto>>,
    TError,
    { photoId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePhoto>>,
  TError,
  { photoId: number },
  TContext
> => {
  return useMutation(getDeletePhotoMutationOptions(options));
};

/**
 * @summary Get profiles for swiping
 */
export const getGetDiscoverProfilesUrl = () => {
  return `/api/discover`;
};

export const getDiscoverProfiles = async (
  options?: RequestInit,
): Promise<DiscoverResponse> => {
  return customFetch<DiscoverResponse>(getGetDiscoverProfilesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDiscoverProfilesQueryKey = () => {
  return [`/api/discover`] as const;
};

export const getGetDiscoverProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof getDiscoverProfiles>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDiscoverProfiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDiscoverProfilesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDiscoverProfiles>>
  > = ({ signal }) => getDiscoverProfiles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDiscoverProfiles>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDiscoverProfilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiscoverProfiles>>
>;
export type GetDiscoverProfilesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get profiles for swiping
 */

export function useGetDiscoverProfiles<
  TData = Awaited<ReturnType<typeof getDiscoverProfiles>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDiscoverProfiles>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDiscoverProfilesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Swipe on a profile
 */
export const getCreateSwipeUrl = () => {
  return `/api/swipes`;
};

export const createSwipe = async (
  swipeBody: SwipeBody,
  options?: RequestInit,
): Promise<SwipeResult> => {
  return customFetch<SwipeResult>(getCreateSwipeUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(swipeBody),
  });
};

export const getCreateSwipeMutationOptions = <
  TError = ErrorType<ErrorResponse | SwipeLimitResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSwipe>>,
    TError,
    { data: BodyType<SwipeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSwipe>>,
  TError,
  { data: BodyType<SwipeBody> },
  TContext
> => {
  const mutationKey = ["createSwipe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSwipe>>,
    { data: BodyType<SwipeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createSwipe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSwipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSwipe>>
>;
export type CreateSwipeMutationBody = BodyType<SwipeBody>;
export type CreateSwipeMutationError = ErrorType<
  ErrorResponse | SwipeLimitResponse
>;

/**
 * @summary Swipe on a profile
 */
export const useCreateSwipe = <
  TError = ErrorType<ErrorResponse | SwipeLimitResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSwipe>>,
    TError,
    { data: BodyType<SwipeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createSwipe>>,
  TError,
  { data: BodyType<SwipeBody> },
  TContext
> => {
  return useMutation(getCreateSwipeMutationOptions(options));
};

/**
 * @summary Get remaining swipes for today
 */
export const getGetSwipesRemainingUrl = () => {
  return `/api/swipes/remaining`;
};

export const getSwipesRemaining = async (
  options?: RequestInit,
): Promise<SwipesRemainingResponse> => {
  return customFetch<SwipesRemainingResponse>(getGetSwipesRemainingUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetSwipesRemainingQueryKey = () => {
  return [`/api/swipes/remaining`] as const;
};

export const getGetSwipesRemainingQueryOptions = <
  TData = Awaited<ReturnType<typeof getSwipesRemaining>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSwipesRemaining>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSwipesRemainingQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSwipesRemaining>>
  > = ({ signal }) => getSwipesRemaining({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSwipesRemaining>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSwipesRemainingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSwipesRemaining>>
>;
export type GetSwipesRemainingQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get remaining swipes for today
 */

export function useGetSwipesRemaining<
  TData = Awaited<ReturnType<typeof getSwipesRemaining>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getSwipesRemaining>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSwipesRemainingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get all matches
 */
export const getGetMatchesUrl = () => {
  return `/api/matches`;
};

export const getMatches = async (
  options?: RequestInit,
): Promise<MatchProfile[]> => {
  return customFetch<MatchProfile[]>(getGetMatchesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMatchesQueryKey = () => {
  return [`/api/matches`] as const;
};

export const getGetMatchesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMatches>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMatches>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMatchesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatches>>> = ({
    signal,
  }) => getMatches({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMatches>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMatchesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMatches>>
>;
export type GetMatchesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get all matches
 */

export function useGetMatches<
  TData = Awaited<ReturnType<typeof getMatches>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMatches>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMatchesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get full profile of a matched user
 */
export const getGetMatchProfileUrl = (matchId: number) => {
  return `/api/matches/${matchId}/profile`;
};

export const getMatchProfile = async (
  matchId: number,
  options?: RequestInit,
): Promise<MatchProfileDetail> => {
  return customFetch<MatchProfileDetail>(getGetMatchProfileUrl(matchId), {
    ...options,
    method: "GET",
  });
};

export const getGetMatchProfileQueryKey = (matchId: number) => {
  return [`/api/matches/${matchId}/profile`] as const;
};

export const getGetMatchProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getMatchProfile>>,
  TError = ErrorType<ErrorResponse>,
>(
  matchId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMatchProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMatchProfileQueryKey(matchId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMatchProfile>>> = ({
    signal,
  }) => getMatchProfile(matchId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!matchId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMatchProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMatchProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMatchProfile>>
>;
export type GetMatchProfileQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get full profile of a matched user
 */

export function useGetMatchProfile<
  TData = Awaited<ReturnType<typeof getMatchProfile>>,
  TError = ErrorType<ErrorResponse>,
>(
  matchId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMatchProfile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMatchProfileQueryOptions(matchId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Unmatch and delete all messages
 */
export const getUnmatchUrl = (matchId: number) => {
  return `/api/matches/${matchId}`;
};

export const unmatch = async (
  matchId: number,
  options?: RequestInit,
): Promise<Unmatch200> => {
  return customFetch<Unmatch200>(getUnmatchUrl(matchId), {
    ...options,
    method: "DELETE",
  });
};

export const getUnmatchMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unmatch>>,
    TError,
    { matchId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unmatch>>,
  TError,
  { matchId: number },
  TContext
> => {
  const mutationKey = ["unmatch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unmatch>>,
    { matchId: number }
  > = (props) => {
    const { matchId } = props ?? {};

    return unmatch(matchId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnmatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof unmatch>>
>;

export type UnmatchMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Unmatch and delete all messages
 */
export const useUnmatch = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unmatch>>,
    TError,
    { matchId: number },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof unmatch>>,
  TError,
  { matchId: number },
  TContext
> => {
  return useMutation(getUnmatchMutationOptions(options));
};

/**
 * @summary Get messages for a match
 */
export const getGetMessagesUrl = (matchId: number) => {
  return `/api/messages/${matchId}`;
};

export const getMessages = async (
  matchId: number,
  options?: RequestInit,
): Promise<MessagesResponse> => {
  return customFetch<MessagesResponse>(getGetMessagesUrl(matchId), {
    ...options,
    method: "GET",
  });
};

export const getGetMessagesQueryKey = (matchId: number) => {
  return [`/api/messages/${matchId}`] as const;
};

export const getGetMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getMessages>>,
  TError = ErrorType<ErrorResponse>,
>(
  matchId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMessagesQueryKey(matchId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMessages>>> = ({
    signal,
  }) => getMessages(matchId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!matchId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMessages>>
>;
export type GetMessagesQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get messages for a match
 */

export function useGetMessages<
  TData = Awaited<ReturnType<typeof getMessages>>,
  TError = ErrorType<ErrorResponse>,
>(
  matchId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMessagesQueryOptions(matchId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Send a message
 */
export const getSendMessageUrl = (matchId: number) => {
  return `/api/messages/${matchId}`;
};

export const sendMessage = async (
  matchId: number,
  sendMessageBody: SendMessageBody,
  options?: RequestInit,
): Promise<Message> => {
  return customFetch<Message>(getSendMessageUrl(matchId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendMessageBody),
  });
};

export const getSendMessageMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessage>>,
    TError,
    { matchId: number; data: BodyType<SendMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { matchId: number; data: BodyType<SendMessageBody> },
  TContext
> => {
  const mutationKey = ["sendMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessage>>,
    { matchId: number; data: BodyType<SendMessageBody> }
  > = (props) => {
    const { matchId, data } = props ?? {};

    return sendMessage(matchId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessage>>
>;
export type SendMessageMutationBody = BodyType<SendMessageBody>;
export type SendMessageMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send a message
 */
export const useSendMessage = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessage>>,
    TError,
    { matchId: number; data: BodyType<SendMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { matchId: number; data: BodyType<SendMessageBody> },
  TContext
> => {
  return useMutation(getSendMessageMutationOptions(options));
};
